import {alias, createModelSchema, list} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";

import {ShipKind} from "./ShipKind";
import {TraderOrder} from "./TraderOrder";
import {TraderOffer} from "./TraderOffer";
import {RewardModel} from "../reward/RewardModel";
import {GuardConfig} from "../guard/GuardConfig";
import {TraderOfferRule} from "@/modules/redactor/models/trader/TraderOfferRule";

export class TraderConfig extends BaseObject {

    constructor() {
        super();
        this._name = null;

        this._guard = new GuardConfig();
        this._trader = ShipKind.NONE;

        this._quantity = 0;

        this._startTime = 0;
        this._safeTime = 0;
        this._duration = 0;

        this._offersCount = 0;
        this._offersRules = [];
        this._offersCustom = [];

        this._ordersCount = 0;
        this._ordersCustom = [];

        this._ordersReward = null;
        this._offersReward = null;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get trader() {
        return this._trader;
    }

    set trader(value) {
        this._trader = value;
    }

    get quantity() {
        return this._quantity;
    }

    set quantity(value) {
        this._quantity = value;
    }

    get startTime() {
        return this._startTime;
    }

    set startTime(value) {
        this._startTime = value;
    }

    get safeTime() {
        return this._safeTime;
    }

    set safeTime(value) {
        this._safeTime = value;
    }

    get duration() {
        return this._duration;
    }

    set duration(value) {
        this._duration = value;
    }


    get ordersCount() {
        return this._ordersCount;
    }

    set ordersCount(value) {
        this._ordersCount = value;
    }

    get ordersCustom() {
        return this._ordersCustom;
    }

    set ordersCustom(value) {
        this._ordersCustom = value;
    }


    get offersCount() {
        return this._offersCount;
    }

    set offersCount(value) {
        this._offersCount = value;
    }

    get offersRules() {
        return this._offersRules;
    }

    set offersRules(value) {
        this._offersRules = value;
    }

    get offersRequired() {
        return this._offersCustom;
    }

    set offersRequired(value) {
        this._offersCustom = value;
    }


    get ordersReward() {
        return this._ordersReward;
    }

    set ordersReward(value) {
        this._ordersReward = value;
    }

    get offersReward() {
        return this._offersReward;
    }

    set offersReward(value) {
        this._offersReward = value;
    }


    valid() {

        if (this.guard && !this.guard.valid()) {
            return false;
        }

        if (!ShipKind.is(this.trader) || ShipKind.NONE.equal(this.trader) || ShipKind.ANY.equal(this.trader)) {
            return false;
        }

        if (!Number.isInteger(this.quantity) || this.quantity < 0) {
            return false;
        }

        if (!Number.isInteger(this.startTime) || this.startTime < 0) {
            return false;
        }

        if (!Number.isInteger(this.safeTime) || this.safeTime < 0) {
            return false;
        }

        if (!Number.isInteger(this.duration) || this.duration < 0) {
            return false;
        }

        if (!Number.isInteger(this.ordersCount) || this.ordersCount <= 0) {
            return false;
        }

        if (!Number.isInteger(this.offersCount) || this.offersCount < 0) {
            return false;
        }

        if (this.ordersCustom && this.ordersCustom.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.offersRequired && this.offersRequired.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.ordersReward && !this.ordersReward.valid()) {
            return false;
        }

        if (this.offersReward && !this.offersReward.valid()) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TraderConfig());
        } else if (target instanceof TraderConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TraderConfig, {
    _name: alias("name", Schema.primitive()),
    _guard: alias("guard", GuardConfig.schema()),
    _trader: alias("trader", ShipKind.schema()),
    _quantity: alias("quantity", Schema.primitive()),

    _startTime: alias("start_time", Schema.primitive()),
    _safeTime: alias("safe_time", Schema.primitive()),
    _duration: alias("duration", Schema.primitive()),

    _ordersCount: alias("orders_count", Schema.primitive()),
    _ordersCustom: alias("orders_list", list(TraderOrder.schema())),


    _offersCount: alias("offers_count", Schema.primitive()),
    _offersRules: alias("offers_rules", list(TraderOfferRule.schema())),
    _offersCustom: alias("offers_list", list(TraderOffer.schema())),


    _ordersReward: alias("orders_reward", RewardModel.schema()),
    _offersReward: alias("offers_reward", RewardModel.schema())
});